import {getBackgroundImage, getPropUnit} from "@/main-page/utils/styleUtils";
import eventBus from "@/events/eventBus";
import GoingUtils from "@/utils/goingUtils";

interface IOutElSty {
  styles:any;
  props:any;
  propsStyl?:any;
  outExtendProp?:any;
}
interface IInnerElSty{
  styles:any;
  props:any;
  innerPropsStyl?:any;
  innerAddProp?:any;
}
const dispSty = ['display', 'flexDirection', 'justifyContent', 'alignItems', 'flexWrap'];
const positionSubSty=[ 'top', 'left', 'bottom', 'right'];
const positionSty = ['position', ...positionSubSty,'zIndex'];
const sizeSty=['width','height'];
const marginSty=['marginTop','marginRight','marginBottom','marginLeft'];
const paddingSty=['paddingTop','paddingRight','paddingBottom','paddingLeft']
const fontSty = ['fontSize', 'lineHeight', 'fontWeight', 'fontColor', 'align', 'opacity', 'cursor'];
const bgColorStyProps=['backgroundColor','linearFlag', 'startBgColor', 'endBgColor'];
const bgImgStyProps=['bgImage', 'backgroundSize', 'backgroundRepeat', 'positionUserDef', 'xpos', 'ypos'];
const bgSty = ['bgType'];
const shadowStyProp=['hShadow', 'vShadow', 'blur', 'spread', 'shadowColor'];
const shadowSty = ['shadowFlag'];
const borderRaduis=[ 'leftTopBorderRadius', 'rightTopBorderRadius', 'leftBottomBorderRadius', 'rightBottomBorderRadius'];
const bdColor=['borderColor'];
const borderSty = ['borderSetType']


export function isPxProp(propName) {
  if (propName === 'marginTop' || propName === 'marginRight' || propName === 'marginBottom' || propName === 'marginLeft') {
    return true;
  }
  if (propName === 'paddingTop' || propName === 'paddingRight' || propName === 'paddingBottom' || propName === 'paddingLeft') {
    return true;
  }
  if (propName === 'fontSize' || propName === 'width' || propName === 'height' || propName === 'lineHeight') {
    return true;
  }
  if (propName === 'top' || propName === 'left' || propName === 'bottom' || propName === 'right') {
    return true;
  }
  return false;
}
const setBorderSty=function (sty,prop, styles){
  sty['--border-color']=styles["borderColor"];
  sty['--border-style']=styles["borderStyle"];
  sty['--bottomBorderWidth']=styles["bottomBorderWidth"];
  sty['--topBorderWidth']=styles["topBorderWidth"];
  sty['--rightBorderWidth']=styles["rightBorderWidth"];
  sty['--leftBorderWidth']=styles["leftBorderWidth"];

  if (styles && styles["bottomBorderWidth"] > 0) {
    sty["border-bottom"] = `${styles["bottomBorderWidth"]}px ${styles["borderStyle"]} ${styles["borderColor"]}`;
  }
  if (styles && styles["topBorderWidth"] > 0) {
    sty["border-top"] = `${styles["topBorderWidth"]}px ${styles["borderStyle"]} ${styles["borderColor"]}`;
  }
  if (styles && styles["rightBorderWidth"] > 0) {
    sty["border-right"] = `${styles["rightBorderWidth"]}px ${styles["borderStyle"]} ${styles["borderColor"]}`;
  }
  if (styles && styles["leftBorderWidth"] > 0) {
    sty["border-left"] = `${styles["leftBorderWidth"]}px ${styles["borderStyle"]} ${styles["borderColor"]}`;
  }
}
const setBorderRaduisSty=function (sty,prop, styles){
    //固定圆角
    if(prop==='borderSetType'&&styles[prop]==='borderSet'){
      sty["border-radius"] = styles["borderRadius"] + GoingUtils.defUnit;
      sty["--borderRadius"] = styles["borderRadius"] + GoingUtils.defUnit;
    }
    //分别定义 圆角
    if(prop==='borderSetType'&&styles[prop]==='borderSingleSet'){
      sty["border-top-left-radius"] = styles["leftTopBorderRadius"] + GoingUtils.defUnit;
      sty["border-top-right-radius"] = styles["rightTopBorderRadius"] + GoingUtils.defUnit;
      sty["border-bottom-right-radius"] = styles["rightBottomBorderRadius"] + GoingUtils.defUnit;
      sty["border-bottom-left-radius"] = styles["leftBottomBorderRadius"] + GoingUtils.defUnit;
    }
}
export const setShadowSty=function (sty,prop, styles){
  sty["box-shadow"] = `${styles['hShadow']}px ${styles['vShadow']}px ${styles['blur']}px ${styles['spread']}px ${styles['shadowColor']}`;
}
/**
 * 获取背景图片信息
 * @param sty
 * @param styles
 */
export const getBgImage=function (sty,prop, styles){
  if((styles[prop]==='bgColor')||styles['backgroundColor']||styles['linearFlag']){
    //背景色
    if(styles['backgroundColor']){
      sty['backgroundColor'] = styles['backgroundColor'];
    }
    //背景渐变色
    if(styles['linearFlag']){
      sty['background'] = `linear-gradient(303deg,${styles['startBgColor']} 10%,${styles['endBgColor']} 80%)`;
    }
  }
  //背景图片
  if (styles['bgImage']) {
    sty['background-image'] = `url('${styles['bgImage']}')`;
    if(!isNaN(parseFloat(styles["xpos"]))){
      sty['background-position'] = `${parseFloat(styles["xpos"])}px ${parseFloat(styles["ypos"])}px`;
    }else{
      sty['background-position'] = `${styles["xpos"]} ${styles["ypos"]}`;
    }
    if (styles["backgroundRepeat"]) {
      sty['background-repeat'] = `${styles["backgroundRepeat"]}`;
    }
    if (styles["backgroundSize"]) {
      sty['background-size'] = `${styles["backgroundSize"]}`;
    }
  }
}

export const isAutoOrBai=function (propVal){
  if((propVal+'').indexOf('%')>0||(propVal+'')==='auto'){
    return true;
  }else{
    return  false;
  }
}

/**
 * 设置边框属性
 * @param sty
 * @param prop
 * @param styles
 */
const initElPxSty=function (sty,prop,styles){
  if(isAutoOrBai(styles[prop])){
    sty[prop] = styles[prop];
    return;
  }
  if (parseFloat(styles[prop]) - styles[prop] === 0) {
    sty[prop] = styles[prop] + getPropUnit(prop, styles)||"px";
  } else {
    sty[prop] = styles[prop];
  }
}

const initStyByProp=function ({sty,props,propsStyl}){
  //如果是元素属性干预 要特殊处理
  if(unref(sty)&&unref(props)&&propsStyl){
    propsStyl.forEach((propName)=>{
      if(unref(props)[propName]){
        //设置宽度
        if(propName==='width'||propName==='height'){
          if(isAutoOrBai(unref(props)[propName])){
            unref(sty)[propName]=unref(props)[propName];
          }else{
            unref(sty)[propName]=unref(props)[propName]+'px';
          }
        }
        if(propName==='heightChange'){
          unref(sty)['height']= `calc(100% - ${unref(props)[propName]||0}px)`;
        }
        //设圆角度
        if(propName==='borderRadius'){
          unref(sty)["border-radius"] = unref(props)["borderRadius"] + GoingUtils.defUnit;
          unref(sty)["--borderRadius"] = unref(props)["borderRadius"] + GoingUtils.defUnit;
        }

        if(propName==='overflow'){
          unref(sty)[propName]=unref(props)[propName]!==false?'auto':'hidden';
        }

        if(propName==='primaryColor'){
          unref(sty)["--primaryColor"] = unref(props)["primaryColor"];
        }

      }
    })
  }
}


export function getOutElStyJsonObj(sty, {styles, props, propsStyl,outExtendProp}:IOutElSty) {
  styles=unref(styles);
  for (const prop in unref(styles)) {
    //如果是外盒子属性
    if(marginSty.includes(prop)){
      initElPxSty(sty,prop,styles);
    }
    if(dispSty.includes(prop)){
      sty[prop]=styles[prop];
    }
    //如果是内盒子属性
    if(paddingSty.includes(prop)){
      initElPxSty(sty,prop,styles);
    }
    //如果是大小属性
    if(sizeSty.includes(prop)){
      initElPxSty(sty,prop,styles);
    }
    //如果是大小属性
    if(positionSty.includes(prop)){
      sty[prop]=styles[prop];
      if(positionSubSty.includes(prop)){
        initElPxSty(sty,prop,styles);
      }
    }
    if(bgSty.includes(prop)){
      getBgImage(sty,prop, styles);
    }
    if(shadowSty.includes(prop)){
      setShadowSty(sty,prop, styles);
    }
    if(fontSty.includes(prop)){
      sty[prop]=styles[prop];
    }
  }
  //如果是元素属性干预 要特殊处理
  initStyByProp({sty,props,propsStyl});
  //如果存在排除属性 将属性移除掉
  if(outExtendProp&&outExtendProp.length>0){
    outExtendProp.forEach((propName)=>{
      for (const propSon in unref(sty)) {
        if((propSon+'').indexOf((propName+''))>=0){
          delete sty[propSon];
        }
      }
    })
  }
}

export function getElStyJsonObj(sty, {styles,props,innerPropsStyl,innerAddProp}:IInnerElSty) {
  styles=unref(styles);
  for (const prop in unref(styles)) {
    if(borderSty.includes(prop)){
      setBorderRaduisSty(sty,prop, styles);
    }
    if(bdColor.includes(prop)){
      setBorderSty(sty,prop, styles);
    }
    if(fontSty.includes(prop)){
      sty['--'+prop]=styles[prop];
      sty[prop]=styles[prop];
    }
  }

  //如果是元素属性干预 要特殊处理
  initStyByProp({sty,props,propsStyl:innerPropsStyl});
  //如果存在追加属性 则进行追加属性的新增
  if(innerAddProp&&innerAddProp.length>0){
    innerAddProp.forEach((propName)=>{

      for (const prop in unref(styles)) {
        if(prop.indexOf(propName)>=0){

          //如果是外盒子属性
          if(marginSty.includes(prop)){
            initElPxSty(sty,prop,styles);
          }
          //如果是内盒子属性
          if(paddingSty.includes(prop)){
            initElPxSty(sty,prop,styles);
          }
          //如果是大小属性
          if(sizeSty.includes(prop)){
            initElPxSty(sty,prop,styles);
          }
        }
      }

    })
  }
}
